module.exports = __webpack_public_path__ + "img/detailsImgBackgroud.f41446ea.png";